import { render, staticRenderFns } from "./ClientMandate.vue?vue&type=template&id=d22a231a&scoped=true"
import script from "./ClientMandate.vue?vue&type=script&lang=js"
export * from "./ClientMandate.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=d22a231a&prod&scoped=true&lang=css&external"
import style1 from "./ClientMandate.vue?vue&type=style&index=1&id=d22a231a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22a231a",
  null
  
)

export default component.exports